module.exports = __webpack_public_path__ + "static/icon-03.fec34296.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-03.png
// module id = 1012
// module chunks = 2